export async function checkBadges(userId) {
  try {
    await fetch('/api/badges', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'check', userId }),
    });
  } catch (err) {
    console.error('Badge check failed', err);
  }
}
